import React from 'react';

import './CookiesBot.scss';

export default class CookiesBot extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: localStorage.getItem("cookiesBot")
    };
  }

  hideCookies = () => {
    localStorage.setItem("cookiesBot", "1");
    this.setState({
      clicked: "1"
    })
  };

  render() {
    if (!this.state.clicked) {
      return (
        <div className="cookiesBot">
          <div>Tento web používá k poskytování služeb, personalizaci reklam a analýze návštěvnosti soubory cookie.
            Používáním tohoto webu s tím souhlasíte. <a
              href="https://www.google.com/intl/cs/policies/technologies/cookies/" className="ws-no-wrap"
              target="_blank">Více informací</a>
          </div>
          <button className="btn ws-no-wrap" onClick={this.hideCookies}>V pořádku</button>
        </div>)
    }
    else {
      return <span/>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CookiesBot/CookiesBot.js